import React from 'react'
import { ProductAllData, ProductStatus } from 'Utils/api/gql/types';
import { getAttribute, getProductFullURL, getCurrentPrice, isDiscounted } from 'Utils/helpers/productAttributeHelper';

type ProductJsonLdProps = {
  product: ProductAllData
}

const StatusMap: { [s in ProductStatus]: string } = {
    [ProductStatus.AVAILABLE]: "http://schema.org/InStock",
    [ProductStatus.OUT_OF_STOCK]: "http://schema.org/OutOfStock",
    [ProductStatus.PERMANENTLY_ENDED]: "http://schema.org/Discontinued",
    [ProductStatus.SEASONAL]: "http://schema.org/OutOfStock",
    [ProductStatus.UNAVAILABLE]: "http://schema.org/OutOfStock",
}

const ProductJsonLd: React.SFC<ProductJsonLdProps> = ({ product }) => {
  const brandAttribute = getAttribute('brand', product.attributes || [])

  let value = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "sku": product.ext_id,
    "gtin": (product.barcodes || []).slice(-1)[0] || undefined,
    "name": product.name,
    "description": product.meta_description || product.description,
    "brand": (brandAttribute && brandAttribute.options && brandAttribute.options.length) ?
      {"@type": "Thing", "name": brandAttribute.options[0].label} :
      undefined,
    "image": (product.images && product.images.length) ?
      [product.images[0].conversions.full, product.images[0].conversions.list, product.images[0].conversions.thumbnail] :
      undefined,
    "offers": {
      "@type": "Offer",
      "availability": StatusMap[product.status],
      "url": getProductFullURL(product),
      "priceCurrency": "HUF",
      "price": getCurrentPrice(product),
      "priceValidUntil": (isDiscounted(product) && product.special_to_date) ?
        new Date(product.special_to_date).toISOString() :
        undefined
    }
   }

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(value) }}
      />
    )
  }

  export default ProductJsonLd
